import { EXTENSIONS_ENUM } from 'constants/ExtensionConstants';

/** @type {import('modules/global/typing/enums/modes.enum').ModeEnum} */
export const TECHNICIAN = 'TECHNICIAN';

/** @type {import('modules/global/typing/enums/modes.enum').ModeEnum} */
export const SALES = 'SALES';

/** @type {import('modules/global/typing/enums/modes.enum').ModeEnum} */
export const AUDIT = 'AUDIT';

/** @type {import('modules/global/typing/enums/modes.enum').ModeEnum} */
export const PARTS = 'PARTS';

/** @type {Array<import('modules/global/typing/enums/modes.enum').ModeEnum>} */
export const ALL_MODES = [TECHNICIAN, SALES, PARTS, AUDIT];

export const MODE_TO_EXTENSION = {
  [TECHNICIAN]: EXTENSIONS_ENUM.AFTER_SALES,
  [PARTS]: EXTENSIONS_ENUM.PARTS,
  [SALES]: EXTENSIONS_ENUM.SALES
};
